import type {EnumValues} from 'src/typings';

export const COLUMN_TYPES = {
    CONTROL: 'CONTROL',
    TOP_COLUMN: 'TOP_COLUMN',
    DATA_COLUMN: 'DATA_COLUMN'
} as const;

export const CONTROL_COLUMN_TYPES = {
    RECORD_LINK: 'RECORD_LINK',
    OPTIONS: 'OPTIONS',
    HOLDINGS: 'HOLDINGS',
    TREE_VIEW: 'TREE_VIEW',
    FOND: 'fond'
};

export const CONTROL_COLUMN_TYPES_SET = [...new Set(Object.values(CONTROL_COLUMN_TYPES))];

export type ColumnType = EnumValues<typeof COLUMN_TYPES>;